import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { MANUAL_RECOMMENDATIONS_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

type ManualRecommendationStatus = 'pending' | 'done' | 'snoozed' | 'dismissed';

export default async function update_manual_recommendation_status_api_call(
  recommendationId: string,
  status: ManualRecommendationStatus
) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${MANUAL_RECOMMENDATIONS_API}/${recommendationId}/status`,
    method: 'PATCH',
    body: applicationWWWXRLEncodedBodyBuilder({
      status: status,
    }),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'UPDATE_MANUAL_RECOMMENDATION_STATUS';
  const customMsg = 'Recommendation status updated successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    return response?.data || true;
  }
}
